import { useNullableContext } from '~/common/contexts/nullableContext';
import { AdminApplicationContext } from '../../AdminApplicationContext';

export const useAdminApplicationContext = () =>
  useNullableContext(
    AdminApplicationContext,
    'useAdminApplicationContext must be used within AdminApplicationProvider',
  );
